const DEFAULT_STATE = {
  coins: [],
  loading: false,
}

export default {
  ...DEFAULT_STATE,
}
